import React from 'react'
import SEO from '../common/SEO'
import ColorSwitcher from '../elements/switcher/ColorSwitcher'
import seoData from '../seoData/GraphicDesigning.json'
import CtaLayoutOne from '../component/cta/CtaLayoutOne'
import FooterOne from '../common/footer/FooterOne'
import HeaderOne from '../common/header/HeaderOne'
import SectionTitle from '../elements/section-title/SectionTitle'
import TestimonialPropTwo from '../component/testimonial/TestimonialPropTwo'
import TestimonialData from '../data/testimonial/TestimonialData.json'
import { slugify } from '../utils'
import PSMFaqSection from '../component/features/PSMFaqSection'
import GraphicDesigningFaqData from '../data/psm/GraphicDesigningFaqData.json'
import GDGrowData from '../data/gd/GDGrowData.json'
import BannerGraphicDesigning from '../component/banner/BannerGraphicDesigning'
import GDServices from '../component/features/GDServices'
import GDBestForYouSection from '../component/features/GDBestForYouSection'
import GDGrowSection from '../component/features/GDGrowSection'
import GDAchievements from '../component/features/GDAchievements'

const allData = TestimonialData;

const GraphicDesigning = () => {
    const facebookData = allData.filter(
        (data) => slugify(data.fromtext) === "facebook"
    );

    return (
        <>
            <SEO {...seoData} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />

                {/* Hero Banner Section */}
                <div className="section section-padding pb-0 ">
                    <BannerGraphicDesigning />
                </div>

                {/* Services Section */}
                <GDServices />

                {/* Best For You Section */}
                <GDBestForYouSection />

                {/* Your Growth Our Priority Section */}
                <GDGrowSection
                    title="Why Choose Us"
                    subtitle="Your Growth Our Priority"
                    textAlignment="heading-center heading-light"
                    textColor=""
                    paragraphClass="d-none"
                    data={GDGrowData}
                    imgUrl={"/images/banner/GD-grow.png"}
                />

                <GDAchievements />

                {/* FAQ Section */}
                <PSMFaqSection faqData={GraphicDesigningFaqData} />

                {/* Testimonials Section */}
                <div className="section section-padding customer-review-area overflow-hidden pb-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <SectionTitle
                                    subtitle=""
                                    title="Testimonials"
                                    textAlignment="heading-left"
                                    textColor=""
                                />
                            </div>
                            <div className="col-lg-4">
                                <div className="review-site-logo"></div>
                            </div>
                        </div>
                        <div className="row">
                            <TestimonialPropTwo
                                colSize="col-lg-3"
                                itemShow="5"
                                layoutStyle="testimonial-dark"
                                testimonialData={facebookData}
                            />
                        </div>
                    </div>
                    <ul className="shape-group-11 list-unstyled">
                        <li className="shape shape-1">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
                                alt="line"
                            />
                        </li>
                        <li className="shape shape-2">
                            <img
                                src={process.env.PUBLIC_URL + "/images/others/circle-3.png"}
                                alt="line"
                            />
                        </li>
                    </ul>
                </div>

                {/* CTA and Footer */}
                <CtaLayoutOne />
                <FooterOne parentClass="" />
            </main >
        </>
    )
}

export default GraphicDesigning